import component from './component.vue';
import directive from './directive.js';

/**
 * Installs the tooltip directive and component for the given instance.
 */
export default {
  install(app) {
    app.component(component.name, component);
    app.directive(directive.name, directive);
  },
};
